var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M17.8801 1.82953C19.2445 -0.609846 22.7548 -0.609842 24.1192 1.82953L40.8157 31.6808C42.1483 34.0634 40.426 37 37.6961 37H4.30318C1.57323 37 -0.149014 34.0634 1.18362 31.6808L17.8801 1.82953Z",
    fill: "#FEA92A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5879"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1202",
    cx: 21.3448,
    cy: 31.8201,
    r: 1.7266,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 148988",
    x: 19.6182,
    y: 7.99298,
    width: 3.45321,
    height: 20.7192,
    rx: 1.7266,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.960f8043a4ef1f5be89e7f9ead939341.svg";
export { ForwardRef as ReactComponent };